import { Vec2 } from '../math/Vec2';

export interface ArenaEdge {
  index: number;
  p1: Vec2;
  p2: Vec2;
  faceAngle: number;
  normal: Vec2;
}

export class Arena {
  center: Vec2 = Vec2.zero();
  radius: number = 100;
  baseAngle: number = Math.PI / 2;

  // Highlight effect when a border/side takes a hit
  hitLineIndex: number = -1;
  hitLineTimer: number = 0;
  lastKillerColor: string = '#ff0055';

  resize(viewportWidth: number, viewportHeight: number): void {
    this.center.set(viewportWidth / 2, viewportHeight / 2);

    if (viewportWidth < 600) {
      // Mobile: 90% of screen width
      this.radius = (viewportWidth * 0.9) / 2;
    } else {
      // Desktop: 40% of smallest dimension
      this.radius = Math.min(viewportWidth, viewportHeight) * 0.4;
    }
  }

  getEdge(index: number, totalSides: number): ArenaEdge {
    const sliceAngle = (Math.PI * 2) / totalSides;
    const startAngle = this.baseAngle + (index - 0.5) * sliceAngle;
    const endAngle = this.baseAngle + (index + 0.5) * sliceAngle;
    const faceAngle = this.baseAngle + index * sliceAngle;

    const p1 = new Vec2(
      this.center.x + this.radius * Math.cos(startAngle),
      this.center.y + this.radius * Math.sin(startAngle)
    );
    const p2 = new Vec2(
      this.center.x + this.radius * Math.cos(endAngle),
      this.center.y + this.radius * Math.sin(endAngle)
    );

    // Inward facing normal for this edge
    const inwardAngle = faceAngle + Math.PI;
    const normal = new Vec2(Math.cos(inwardAngle), Math.sin(inwardAngle));

    return { index, p1, p2, faceAngle, normal };
  }

  getAllEdges(totalSides: number): ArenaEdge[] {
    const edges: ArenaEdge[] = [];
    for (let i = 0; i < totalSides; i++) {
      edges.push(this.getEdge(i, totalSides));
    }
    return edges;
  }

  triggerHitLine(sideIndex: number, color: string): void {
    this.hitLineIndex = sideIndex;
    this.hitLineTimer = 60; // Glow for ~1 second (60 ticks)
    this.lastKillerColor = color;
  }

  update(): void {
    if (this.hitLineTimer > 0) {
      this.hitLineTimer--;
    }
  }
}
